import { coreTranslations } from 'translations';

const settingsMenuItems = _rootMenu;

function _rootMenu() {
    return {
        i18n: coreTranslations.ng_core_settings,
        linkTitle: 'Settings',
        icon: 'onsolve-settings-icon',
        routeTo: '/settings',
        isRenderable: true
    };
}

export default settingsMenuItems;
